import { ITournamentTick } from "pkm-special-tool"
import { ServerCall } from "./ServerCall"

export class TournamentTickService extends ServerCall{
    public static getTicks = (tournamentId: string) => this.get<ITournamentTick[]>("tournament-ticks/" + tournamentId)

    public static setTicks = (tournamentId: string, playerId: number) => this.post("tournament-ticks/" + tournamentId, { playerId })
}